import { render, staticRenderFns } from "./UserPermissions.vue?vue&type=template&id=61eec75e&scoped=true"
import script from "./UserPermissions.vue?vue&type=script&lang=js"
export * from "./UserPermissions.vue?vue&type=script&lang=js"
import style0 from "./UserPermissions.vue?vue&type=style&index=0&id=61eec75e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eec75e",
  null
  
)

export default component.exports